"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'AudioProcessingEvent',
    'BeforeInputEvent',
    'BeforeUnloadEvent',
    'BlobEvent',
    'ClipboardEvent',
    'CloseEvent',
    'CompositionEvent',
    'CSSFontFaceLoadEvent',
    'DeviceLightEvent',
    'DeviceMotionEvent',
    'DeviceOrientationEvent',
    'DeviceProximityEvent',
    'DOMTransactionEvent',
    'DragEvent',
    'EditingBeforeInputEvent',
    'FetchEvent',
    'GamepadEvent',
    'HashChangeEvent',
    'IDBVersionChangeEvent',
    'MediaStreamEvent',
    'MessageEvent',
    'MutationEvent',
    'OfflineAudioCompletionEvent',
    'OverconstrainedError',
    'PageTransitionEvent',
    'PaymentRequestUpdateEvent',
    'PopStateEvent',
    'ProgressEvent',
    'RelatedEvent',
    'RTCDataChannelEvent',
    'RTCIdentityErrorEvent',
    'RTCIdentityEvent',
    'RTCPeerConnectionIceEvent',
    'SensorEvent',
    'SVGEvent',
    'SVGZoomEvent',
    'TimeEvent',
    'TouchEvent',
    'TrackEvent',
    'TransitionEvent',
    'UserProximityEvent',
    'WebGLContextEvent'
];
//# sourceMappingURL=NonImplementedEventTypes.js.map